"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryGroup = void 0;
var CountryGroup;
(function (CountryGroup) {
    CountryGroup[CountryGroup["Southern Europe"] = 0] = "Southern Europe";
    CountryGroup[CountryGroup["Northern Europe"] = 1] = "Northern Europe";
    CountryGroup[CountryGroup["Western Europe"] = 2] = "Western Europe";
    CountryGroup[CountryGroup["Eastern Europe"] = 3] = "Eastern Europe";
    CountryGroup[CountryGroup["Africa"] = 4] = "Africa";
    CountryGroup[CountryGroup["SE Asia"] = 5] = "SE Asia";
    CountryGroup[CountryGroup["Central America"] = 6] = "Central America";
    CountryGroup[CountryGroup["LATAM"] = 7] = "LATAM";
    CountryGroup[CountryGroup["Europe"] = 8] = "Europe";
    CountryGroup[CountryGroup["Southern S. America"] = 9] = "Southern S. America";
    CountryGroup[CountryGroup["Northern S. America"] = 10] = "Northern S. America";
    CountryGroup[CountryGroup["Southern Africa"] = 11] = "Southern Africa";
    CountryGroup[CountryGroup["Northern Africa"] = 12] = "Northern Africa";
    CountryGroup[CountryGroup["Western Africa"] = 13] = "Western Africa";
    CountryGroup[CountryGroup["Eastern Africa"] = 14] = "Eastern Africa";
    CountryGroup[CountryGroup["North America"] = 15] = "North America";
    CountryGroup[CountryGroup["Middle East"] = 16] = "Middle East";
    CountryGroup[CountryGroup["Oceania"] = 17] = "Oceania";
    // temporary groups of single country
    CountryGroup[CountryGroup["Mexico"] = 101] = "Mexico";
    CountryGroup[CountryGroup["Costa Rica"] = 102] = "Costa Rica";
    CountryGroup[CountryGroup["Morocco"] = 103] = "Morocco";
    CountryGroup[CountryGroup["Egypt"] = 104] = "Egypt";
    CountryGroup[CountryGroup["Other"] = 998] = "Other";
    CountryGroup[CountryGroup["All"] = 999] = "All";
})(CountryGroup || (exports.CountryGroup = CountryGroup = {}));
//# sourceMappingURL=CountryGroup.js.map